import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]

  connect() {
    this.nextIndex = Date.now()
  }

  add() {
    this.listTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("NEW_OFFICIAL", this.nextIndex++))
  }

  remove(event) {
    const row = event.target.closest("[data-official-row]")
    row.querySelector("[data-destroy-field]").value = "1"
    row.hidden = true
  }
}
